export default __webpack_public_path__ + "static/media/slide3.3aae95c3.jpg";